function isRetina() {
  if (process.env.BROWSER && window) {
    return window.devicePixelRatio >= 2;
  }
  return false;
}

function isAvailableRetinaImageSize(image, options, factor = 2) {
  return image.width >= options.width * factor &&
    image.height >= options.height * factor;
}

function getImageSize(image, options, useRetinaImageSize, factor = 2) {
  if (useRetinaImageSize && isAvailableRetinaImageSize(image, options)) {
    return {
      width: options.width * factor,
      height: options.height * factor,
    }
  }
  return {
    width: options.width,
    height: options.height,
  }
}

function getImageSizeString(size) {
  if (size.width && size.height) {
    return `${size.width}-${size.height}`;
  }
  return `${size.width}`;
}

function generateImageSrc(imageSrc, imageSize) {
  if (!imageSrc) {
    return false;
  }

  let isWebpSupport = true;
  const imageSizeString = getImageSizeString(imageSize);

  let processedImageSrc = imageSrc;
  if (imageSrc.indexOf('productimages') > -1) {
    isWebpSupport = false;
    if (imageSrc.indexOf('#imgSize') > -1) {
      processedImageSrc = imageSrc.replace('#imgSize', imageSizeString);
    } else if (imageSrc.indexOf('{size}') > -1) {
      processedImageSrc = imageSrc.replace('{size}', imageSizeString);
    }
  } else if (imageSrc.indexOf('dali-banner') > -1) {
    if (imageSrc.indexOf('#imgSize') > -1) {
      processedImageSrc = imageSrc.replace('#imgSize', imageSizeString);
    } else if (imageSrc.indexOf('{size}') > -1) {
      processedImageSrc = imageSrc.replace('{size}', imageSizeString);
    }
  } else if (imageSrc.indexOf('images') > -1) {
    if (imageSrc.indexOf('#imgSize') > -1) {
      processedImageSrc = imageSrc.replace('#imgSize', imageSizeString);
    } else if (imageSrc.indexOf('{size}') > -1) {
      processedImageSrc = imageSrc.replace('{size}', imageSizeString);
    }
  } else {
    if (imageSrc.indexOf('#imgSize') > -1) {
      processedImageSrc = imageSrc.replace('#imgSize', '135');
    } else if (imageSrc.indexOf('{size}') > -1) {
      processedImageSrc = imageSrc.replace('{size}', '135');
    }
  }

  return {
    isWebpSupport: isWebpSupport,
    png: processedImageSrc,
    webp: `${processedImageSrc}/format:webp`,
  };
}

function generateImageSrcSet(image, imageSize, src) {
  if (!image || !imageSize) {
    return false;
  }

  const retinaFactor = 2;
  let isWebpSupport = true;
  let setRetinaImageUrl;

  const imageSizeString = getImageSizeString({
    width: imageSize.width * retinaFactor,
    height: imageSize.height * retinaFactor,
  })

  if (src.indexOf('productimages') > -1) {
    isWebpSupport = false;
    if (src.indexOf('#imgSize') > -1) {
      setRetinaImageUrl = src.replace('#imgSize', imageSizeString);
    } else if (src.indexOf('{size}') > -1) {
      setRetinaImageUrl = src.replace('{size}', imageSizeString);
    }
  } else if (src.indexOf('dali-banner') > -1) {
    if (src.indexOf('#imgSize') > -1) {
      setRetinaImageUrl = src.replace('#imgSize', imageSizeString);
    } else if (src.indexOf('{size}') > -1) {
      setRetinaImageUrl = src.replace('{size}', imageSizeString);
    }
  } else if (src.indexOf('images') > -1) {
    if (src.indexOf('#imgSize') > -1) {
      setRetinaImageUrl = src.replace('#imgSize', imageSizeString);
    } else if (src.indexOf('{size}') > -1) {
      setRetinaImageUrl = src.replace('{size}', imageSizeString);
    }
  } else {
    if (src.indexOf('#imgSize') > -1) {
      setRetinaImageUrl = src.replace('#imgSize', '135');
    } else if (src.indexOf('{size}') > -1) {
      setRetinaImageUrl = stripColor.replace('{size}', '135');
    }
  }
  const result = {
    isWebpSupport: isWebpSupport,
    png: image,
    png2x: setRetinaImageUrl,
    webp: `${image}/format:webp`,
    webp2x: `${setRetinaImageUrl}/format:webp`,
  };
  return result;
}

export {
  isRetina,
  isAvailableRetinaImageSize,
  getImageSize,
  getImageSizeString,
  generateImageSrc,
  generateImageSrcSet,
}
